import {RenderAuditLogsEnrichment, RendererProps} from "../RendererProps";
import {ReactElement, useMemo} from "react";
import {budgetSeasonString, ensureNotObject, keyify} from "../common";
import * as common from "../styles/common.module.scss";

const MONTH_VALUES = [
    "valueM0",
    "valueM1",
    "valueM2",
    "valueM3",
    "valueM4",
    "valueM5",
    "valueM6",
    "valueM7",
    "valueM8",
    "valueM9",
    "valueM10",
    "valueM11"
];

function renderValueUnitTypeArray(name: string, valueMult: number, arr: any, unitTypeMap: Record<string, RenderAuditLogsEnrichment["unitTypes"][0]>): ReactElement {
    if(arr === null || arr === undefined || !Array.isArray(arr) || arr.length === 0) {
        return <></>;
    }

    const values: ReactElement[] = [];
    for(const obj of arr) {
        if(typeof obj !== "object" || obj === null) {
            continue;
        }

        for(let i = 0; i < MONTH_VALUES.length; i++) {
            const monthProp = MONTH_VALUES[i];
            if(!monthProp) {
                continue;
            }

            let monthVal = obj[monthProp];
            const unitTypeId = obj["unitTypeId"];
            const forecastPeriod = obj["versionType"];
            if(monthVal === undefined) {
                continue;
            }

            if(typeof monthVal === "number") {
                monthVal *= valueMult;
            }

            const unitType = unitTypeMap[unitTypeId];

            values.push(<li key={`${keyify(unitTypeId)}-${i}`}>
                {unitType ? `(${unitType.name}) `: "(UNKNOWN) "}{forecastPeriod ? `${ensureNotObject(forecastPeriod)} `: ""} Month {i + 1}: {monthVal === null ? "Removed" : ensureNotObject(monthVal)}
            </li>);
        }
    }

    return <div>
        <div className={common.textSubHeader}>{name}</div>
        {values.length > 0 ?
            <ul>
                {values}
            </ul> :
            <div>Unknown Changes</div>
        }
    </div>;
}

export interface RenderSetUnitTypePMSOverridesProps extends RendererProps {
    enrichment?: RenderAuditLogsEnrichment;
}

export function RenderSetUnitTypePMSOverrides(props: RenderSetUnitTypePMSOverridesProps): ReactElement {
    const budgetYear = props.variables["budgetYear"];
    const occupancyType = props.variables["occupancy"];
    const unitCount = props.variables["unitCount"];
    const inPlaceRent = props.variables["inPlaceRent"];
    const actuals = props.variables["overridesActuals"];
    const forecasts = props.variables["overrides"];

    const unitTypes = props.enrichment?.unitTypes;
    const unitTypeMap: Record<string, RenderAuditLogsEnrichment["unitTypes"][0]> = useMemo(() => {
        if(unitTypes) {
            return unitTypes.toIdMap(u => u.id);
        }
        return {};
    }, [unitTypes]);

    return <div>
        <div className={common.textHeader}>{budgetSeasonString(budgetYear)}</div>
        {renderValueUnitTypeArray("Occupancy", 100, occupancyType, unitTypeMap)}
        {renderValueUnitTypeArray("Unit Count", 1, unitCount, unitTypeMap)}
        {renderValueUnitTypeArray("In-Place Rent", 1, inPlaceRent, unitTypeMap)}
        {renderValueUnitTypeArray("In-Place Rent Actuals", 1, actuals, unitTypeMap)}
        {renderValueUnitTypeArray("In-Place Rent Forecast", 1, forecasts, unitTypeMap)}
    </div>;
}